function snapToPrecision(
  val: number,
  min: number,
  max: number,
  precision: number,
) {
  const normalized = Math.round((val - min) / precision) * precision + min;
  return Math.max(min, Math.min(max, Number(normalized.toFixed(10))));
}

export { snapToPrecision };
